export {default} from './AsyncWidgetStats';
